import { ErrorModal } from './ErrorModal';
import { useErrorModal } from '../../hooks/useErrorModal';

export function GlobalErrorModal() {
  const { isOpen, errorMessage, correlationId, onClose } = useErrorModal();

  return <ErrorModal isOpen={isOpen} errorMessage={errorMessage} correlationId={correlationId} onClose={onClose} />;
}
